
export const MINIMUM_REQUIRED_INSURANCE_PRICE = 1000000
export const MINIMUM_KREDIVO_PRICE = 500000
export const MINIMUM_CREDIT_CARD_INSTALLMENT_BCA_PRICE = 5000000
export const MINIMUM_CREDIT_CARD_INSTALLMENT_BNI_PRICE = 3000000